import { useState } from 'react';
import { api } from '../api';
import { useAuth } from '../auth';
import { useAction, useApi } from '../hooks';
import { Champ, Chargement, MessageErreur, Modal, Statut, formatDate } from '../components/ui';

export default function Utilisateurs() {
  const { utilisateur: moi } = useAuth();
  const utilisateurs = useApi('/utilisateurs');
  const { donnees: roles } = useApi('/utilisateurs/roles');
  const [modal, setModal] = useState(null);

  if (utilisateurs.erreur) return <MessageErreur erreur={utilisateurs.erreur} />;
  if (!utilisateurs.donnees || !roles) return <Chargement />;

  return (
    <>
      <div className="titre-page">
        <h1>Utilisateurs</h1>
        <button className="btn btn-principal" onClick={() => setModal({})}>
          + Nouvel utilisateur
        </button>
      </div>
      <div className="carte">
        <table>
          <thead>
            <tr>
              <th>Nom d'utilisateur</th>
              <th>Nom</th>
              <th>Email</th>
              <th>Rôle</th>
              <th>Dernière connexion</th>
              <th>Statut</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {utilisateurs.donnees.map((u) => (
              <tr key={u.id}>
                <td>
                  {u.username} {u.id === moi.id && <span className="muted">(vous)</span>}
                </td>
                <td>{[u.firstName, u.lastName].filter(Boolean).join(' ') || '—'}</td>
                <td>{u.email}</td>
                <td>{u.role.name}</td>
                <td>{formatDate(u.lastLoginAt, true)}</td>
                <td>
                  <Statut valeur={u.status} />
                </td>
                <td>
                  <button className="btn btn-lien" onClick={() => setModal({ utilisateur: u })}>
                    Modifier
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <FormulaireUtilisateur
          utilisateur={modal.utilisateur}
          roles={roles}
          onFermer={() => setModal(null)}
          onEnregistre={() => {
            setModal(null);
            utilisateurs.recharger();
          }}
        />
      )}
    </>
  );
}

function FormulaireUtilisateur({ utilisateur, roles, onFermer, onEnregistre }) {
  const { executer, enCours, erreur } = useAction();
  const [valeurs, setValeurs] = useState({
    username: utilisateur?.username || '',
    email: utilisateur?.email || '',
    firstName: utilisateur?.firstName || '',
    lastName: utilisateur?.lastName || '',
    role: utilisateur?.role.code || 'USER',
    status: utilisateur?.status || 'ACTIVE',
    motDePasse: '',
  });
  const champ = (cle) => ({ value: valeurs[cle], onChange: (e) => setValeurs({ ...valeurs, [cle]: e.target.value }) });

  const soumettre = (e) => {
    e.preventDefault();
    executer(async () => {
      const { motDePasse, ...corps } = valeurs;
      // En modification, un mot de passe vide n'est pas changé
      if (motDePasse) corps.motDePasse = motDePasse;
      if (utilisateur) await api(`/utilisateurs/${utilisateur.id}`, { methode: 'PUT', corps });
      else await api('/utilisateurs', { methode: 'POST', corps: { ...corps, motDePasse } });
      onEnregistre();
    });
  };

  return (
    <Modal titre={utilisateur ? `Modifier ${utilisateur.username}` : 'Nouvel utilisateur'} onFermer={onFermer}>
      <form onSubmit={soumettre}>
        <MessageErreur erreur={erreur} />
        <div className="grille-2">
          <Champ libelle="Nom d'utilisateur *">
            <input {...champ('username')} required />
          </Champ>
          <Champ libelle="Email *">
            <input type="email" {...champ('email')} required />
          </Champ>
          <Champ libelle="Prénom">
            <input {...champ('firstName')} />
          </Champ>
          <Champ libelle="Nom">
            <input {...champ('lastName')} />
          </Champ>
          <Champ libelle="Rôle">
            <select {...champ('role')}>
              {roles.map((r) => (
                <option key={r.id} value={r.code}>
                  {r.name}
                </option>
              ))}
            </select>
          </Champ>
          <Champ libelle="Statut">
            <select {...champ('status')}>
              <option value="ACTIVE">Actif</option>
              <option value="INACTIVE">Inactif</option>
            </select>
          </Champ>
        </div>
        <Champ
          libelle={utilisateur ? 'Nouveau mot de passe' : 'Mot de passe *'}
          aide={utilisateur ? 'Laisser vide pour ne pas le changer' : 'Au moins 8 caractères'}
        >
          <input type="password" autoComplete="new-password" {...champ('motDePasse')} required={!utilisateur} minLength={8} />
        </Champ>
        <div className="actions-modal">
          <button type="button" className="btn btn-secondaire" onClick={onFermer}>
            Annuler
          </button>
          <button className="btn btn-principal" disabled={enCours}>
            Enregistrer
          </button>
        </div>
      </form>
    </Modal>
  );
}
